import { render, staticRenderFns } from "./AdminPromotionsWidget.vue?vue&type=template&id=434221ce"
import script from "./AdminPromotionsWidget.vue?vue&type=script&lang=js"
export * from "./AdminPromotionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports